export const mutations = {
  STORE_SUPPLIERS(state, suppliers) {
    state.suppliers = suppliers;
  },
  STORE_SUPPLIER_UPDATE(state, supplierId) {
    let Supplier = state.suppliers.find(function(supplier) {
      return supplier.id === supplierId;
    });
    state.systemSupplier = Supplier;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/suppliers/mutations.js